import React from 'react';
import StyledLoginUnsuccessful, {
  CircleAlert
} from './LoginUnsuccessful.style';
import StyledText from './Text.style';

const LoginUnsuccessful = () => (
  <StyledLoginUnsuccessful>
    <CircleAlert />
    <StyledText>Login unsuccessful. Please try again.</StyledText>
  </StyledLoginUnsuccessful>
);

export default LoginUnsuccessful;
